import { Argumentos, MapaDeComandos, Respuesta, Resultados } from './protocolo';

export class ErrorConDetalles extends Error {
    public name: string;
    public mensajeParaUsuario: string;
    public detalles: Array<string>;

    public constructor(mensaje: string, detalles: Array<string> = []) {
        super(mensaje);

        // Si la clase es transpilada a ES5, como es nuestro caso, la llamada a super sobreescribe
        // la referencia a this y por tanto toda la cadena de prototipos podría estar mal.
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ErrorConDetalles.prototype);

        this.name = this.constructor.name;
        this.mensajeParaUsuario = mensaje;
        this.detalles = detalles;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = new Error(mensaje).stack;
        }
    }
}
type NombresDeComandos = keyof MapaDeComandos;

export { Argumentos, Resultados, Respuesta, NombresDeComandos };



// WEBPACK FOOTER //
// ./src/api/fetcher.ts